import React from 'react';
import welcome1 from './assets/welcome1.jpg'; // assicurati che siano in questa cartella
import welcome2 from './assets/welcome2.jpg';
import './Welcomematricole.css';

function WelcomeMatricole() {
  return (
    <div className="welcome-matricole-container">
      <p className="welcome-description">
        Welcome Matricole è l'evento di benvenuto per tutti i nuovi iscritti...
      </p>
      <img src={welcome1} alt="Welcome 1" className="welcome-image" />
      <img src={welcome2} alt="Welcome 2" className="welcome-image" />
    </div>
  );
}

export default WelcomeMatricole;
